import { ReactNode, useCallback, useRef } from 'react';

type Data<T> = T[] | null;
interface LoaderResult<T> {
    data: Data<T>;
    hasMore: boolean;
}
type Loader<T> = (currentData: Data<T>, isReload: boolean) => Promise<LoaderResult<T>>;

interface Position<T> {
    index: number;
    item: T;
}

export interface ButtonPaginationProps<T> {
    loader: Loader<T>;
    children(item: T[]): ReactNode | ReactNode[];
    buttonClassName?: string;
}

export interface ScrollPaginationProps<T> {
    loader: Loader<T>;
    children(item: T[]): ReactNode | ReactNode[];
}

export function useLocalPagination<T>(data: Data<T>, pageSize: number | null = 10): Loader<T> {
    const position = useRef<Position<T> | null>(null);

    return useCallback(
        async (currentData, isReload = false) => {
            let index = 0;

            if (data === null) {
                return Promise.resolve({ data: null, hasMore: false });
            }

            if (pageSize === null) {
                return Promise.resolve({ data: data.slice(), hasMore: false });
            }

            if (position.current) {
                // index = data.indexOf(position.current.item);

                // if (index < 0) {
                //     index = position.current.index;
                // }

                index = position.current.index;
            }

            const extraItemsToLoad = isReload ? 0 : pageSize;

            const lastItemIndex = Math.min(Math.max(index + extraItemsToLoad, pageSize), data.length);

            const newData = data.slice(0, lastItemIndex);

            position.current =
                newData.length > 0
                    ? {
                          item: newData[lastItemIndex],
                          index: lastItemIndex,
                      }
                    : null;

            return Promise.resolve({ data: newData, hasMore: lastItemIndex < data.length });
        },
        [data, pageSize]
    );
}

export { default as ButtonPagination } from './ButtonPagination';
export { default as ScrollPagination } from './ScrollPagination';